import { api } from './BaseApi'
import {
  IBuffetDish,
  IBuffetDishByCategoryDto,
  IBuffetDishDto,
  IBuffetDishesRequest,
  IBuffetDishesResponse,
  IBuffetDishesWithImplInfoDtoResponse,
  IBuffetDishUploadDto,
  ICreateBuffetDishDto,
  ISendDishesToFotoboxesRequest,
  IBuffetDishesCategoryResponse,
} from './dto/BuffetDishDto'
import { createQueryStringSmart } from 'utils/createQueryString'

export const buffetDishApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getBuffetDish: builder.query<IBuffetDishesResponse, IBuffetDishesRequest>({
      query: (params) => ({
        url: `/buffet_dish/${createQueryStringSmart(params)}`,
      }),
      providesTags: ['ВuffetDish'],
    }),
    getBuffetDishSimpleList: builder.query<
      IBuffetDishesResponse,
      IBuffetDishesRequest
    >({
      query: (params) => ({
        url: `/buffet_dish/get_dish_simple_info/${createQueryStringSmart(
          params,
        )}`,
      }),

      providesTags: ['ВuffetDish'],
    }),
    getBuffetDishDetail: builder.query<IBuffetDishDto, { id: number }>({
      query: ({ id }) => ({
        url: `/buffet_dish/${id}/`,
      }),
      providesTags: ['ВuffetDish', 'Tags'],
    }),
    getLoadBuffetDishesFromSh: builder.query<{ detail: string }, null>({
      query: () => ({
        url: '/buffet_dish/load_dishes_from_source/',
      }),
      providesTags: ['ВuffetDish'],
    }),
    getBuffetDishByCategory: builder.query<
      IBuffetDishesCategoryResponse,
      { search?: string }
    >({
      query: ({ search }) => ({
        url: `/buffet_dish/get_dishes_split_by_category/`,
        params: { search },
      }),
      providesTags: ['ВuffetDish'],
    }),
    getDishesFromOrdersByCategories: builder.query<
      IBuffetDishesWithImplInfoDtoResponse,
      { category?: number; order_ids?: string }
    >({
      query: (params) => ({
        url: `/buffet_dish/get_dishes_from_orders_by_categories/`,
        params: !!params ? params : {},
      }),
      providesTags: ['ВuffetDish'],
    }),

    createBuffetDish: builder.mutation<
      IBuffetDishDto,
      FormData | ICreateBuffetDishDto
    >({
      query: (body) => ({
        method: 'POST',
        url: '/buffet_dish/',
        body,
      }),
      invalidatesTags: ['ВuffetDish'],
    }),
    // createBuffetDish: builder.mutation<IBuffetDishDto, ICreateBuffetDishDto>({
    //   query: (body) => ({
    //     method: 'POST',
    //     url: '/buffet_dish/',
    //     body,
    //   }),
    //   invalidatesTags: ['ВuffetDish'],
    // }),
    updateBuffetDish: builder.mutation<
      IBuffetDishDto,
      { id: number; data: Partial<ICreateBuffetDishDto> }
    >({
      query: ({ id, data }) => ({
        method: 'PATCH',
        url: `/buffet_dish/${id}/`,
        body: data,
      }),
      invalidatesTags: ['ВuffetDish'],
    }),
    uploadCSVBuffetDish: builder.mutation<
      IBuffetDishUploadDto,
      { data: FormData }
    >({
      query: ({ data }) => ({
        method: 'POST',
        url: '/buffet_dish/load_dishes_from_file_csv/',
        data,
        body: data,
      }),
    }),
    uploadBuffetDish: builder.mutation<
      IBuffetDishUploadDto,
      { data: FormData }
    >({
      query: ({ data }) => ({
        method: 'POST',
        url: '/buffet_dish/load_dishes_from_file_xlsx/',
        data,
        body: data,
      }),
      invalidatesTags: ['ВuffetDish'],
    }),
    updateUploadedBuffetDish: builder.mutation<
      IBuffetDishUploadDto,
      { data: IBuffetDish[] }
    >({
      query: ({ data }) => ({
        method: 'PATCH',
        url: '/buffet_dish/update_dishes/',
        body: data,
      }),
      invalidatesTags: ['ВuffetDish'],
    }),
    archiveMultipleBuffetDish: builder.mutation<
      IBuffetDishDto,
      { dishes: number[] }
    >({
      query: ({ dishes }) => ({
        method: 'PATCH',
        url: `/buffet_dish/archive_multiple_dishes/`,
        body: { dishes },
      }),
      invalidatesTags: ['ВuffetDish'],
    }),
    deletePhotoBuffetDish: builder.mutation<
      IBuffetDishDto,
      { dish_id: number }
    >({
      query: ({ dish_id }) => ({
        method: 'PATCH',
        url: `/buffet_dish/clear_image_and_s3_links/`,
        body: { dish_id },
      }),
      invalidatesTags: ['ВuffetDish'],
    }),
  }),
})

export const {
  useGetBuffetDishQuery,
  useGetBuffetDishSimpleListQuery,
  useGetBuffetDishDetailQuery,
  useGetBuffetDishByCategoryQuery,
  useGetDishesFromOrdersByCategoriesQuery,
  // useLazyGetImageDishFromCameraQuery,
  useGetLoadBuffetDishesFromShQuery,
  useUpdateBuffetDishMutation,
  useCreateBuffetDishMutation,
  useUploadBuffetDishMutation,
  useUploadCSVBuffetDishMutation,
  useUpdateUploadedBuffetDishMutation,
  useArchiveMultipleBuffetDishMutation,
  useDeletePhotoBuffetDishMutation,
} = buffetDishApi
